import {DEBUG, REST_SERVER_URL, TAG, ENV_NAME} from './config';

export interface IAppConstants {
  archiSmallAppVersion: string;
  restServer: string;
  workerWaitTimeoutMilliseconds: number;
  requestWebserviceTimeoutMilliseconds: number;
  workerNameSuffix: string;
  fatturaPAAttachmentMaxSize: number;
  fattureAttiveMaxFilesToUpload: number;
  fatturaPAeNotificheMaxFilesToUpload: number;
  fatturaElettronicaPassivaMaxFilesToUpload: number;
  fatturaGSEeNotificheMaxFilesToUpload: number;
  fatturaPAMaxFilesToUpload: number;
  mailPecMaxFilesToUpload: number;
  testEnvironment: boolean;
  archiSmallMaintenance: boolean;
  showMaintenanceAlert: boolean;
  WSRetryRequestsDelay: number;
  WSAutoRetryRequestsNumber: number;
  chartMinPercentageValue: number;
  dateFormat: string;
}

export const AppConstants: IAppConstants = {
  archiSmallAppVersion: TAG,
  restServer: REST_SERVER_URL,
  workerWaitTimeoutMilliseconds: 5000,
  requestWebserviceTimeoutMilliseconds: 10000,
  workerNameSuffix: '_' + ENV_NAME.toLowerCase(),
  fatturaPAAttachmentMaxSize: 2048000,
  fattureAttiveMaxFilesToUpload: 1,
  fatturaPAeNotificheMaxFilesToUpload: 500,
  fatturaElettronicaPassivaMaxFilesToUpload: 500,
  fatturaGSEeNotificheMaxFilesToUpload: 1,
  fatturaPAMaxFilesToUpload: 500,
  mailPecMaxFilesToUpload: 100,
  testEnvironment: DEBUG,
  archiSmallMaintenance: false,
  showMaintenanceAlert: false,
  WSRetryRequestsDelay: 1000,
  WSAutoRetryRequestsNumber: 5,
  chartMinPercentageValue: 2,
  dateFormat: 'dd/MM/yyyy'
};

export const restServer: string = REST_SERVER_URL;

export const storageBaseUrl: string = 'https://storage.googleapis.com/';

export const PAYMILL_PUBLIC_KEY = '1789816287696e18a48186e0fc769d2e';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/app.constants.ts